import { FC } from 'react'
import HistoryListBlock from '../../blocks/HistoryListBlock/HistoryListBlock'
import type { LeadProfileLead } from '../../LeadProfileModal.types'

interface WideHistoryContentProps {
  lead: LeadProfileLead
  refreshKey?: number
}

const WideHistoryContent: FC<WideHistoryContentProps> = ({ lead, refreshKey }) => {
  return <HistoryListBlock lead={lead} refreshKey={refreshKey} />
}

export default WideHistoryContent
